// extracted by mini-css-extract-plugin
module.exports = {"disable-scroll":"_3k71hxl4pWsgvH4ZErA_0N"};